import React from "react";

import CommonPrintMailSwitchModalPartial from "../../../commons/container/App/PrintMailSwitchModalPartial";

type PrintMailSwitchModalPartialProps = React.ComponentProps<typeof CommonPrintMailSwitchModalPartial>;

const PrintMailSwitchModalPartial = (props: PrintMailSwitchModalPartialProps) => {
  return <CommonPrintMailSwitchModalPartial {...props} isOffline={false} isUsbPrinterConnected={false} />;
};

export default PrintMailSwitchModalPartial;
